import { Link, useParams } from "react-router-dom";
import { getDemoDeal } from "../../data/portalDeals.js";
import { useState } from "react";

export default function PortalDealDetail() {
  const { slug } = useParams();
  const deal = getDemoDeal(slug);

  // In Phase 3 this comes from /api/nda/status?deal=:slug
  // For demo, treat as not-signed by default
  const [ndaSigned] = useState(false);

  if (!deal) {
    return (
      <div className="portal-page">
        <p>Deal not found.</p>
        <Link to="/portal/pipeline" className="portal-link">← Back to pipeline</Link>
      </div>
    );
  }

  function fmtCcy(amount) {
    if (amount == null) return "—";
    const sym = deal.currency === "GBP" ? "£" : deal.currency === "USD" ? "$" : deal.currency === "EUR" ? "€" : "";
    if (amount >= 1_000_000) return `${sym}${(amount / 1_000_000).toFixed(1)}m`;
    return `${sym}${amount.toLocaleString()}`;
  }

  return (
    <div className="portal-page">
      <div className="portal-breadcrumb">
        <Link to="/portal/pipeline" className="portal-link">Pipeline</Link> / <span>{deal.name}</span>
      </div>
      <h1 className="portal-h1">{deal.name}</h1>
      <div className="muted">
        <span className="type-pill">{deal.sector}</span>
        {" · "}{deal.location}
      </div>

      <section className="portal-card">
        <h2 className="portal-h2">Headline</h2>
        <p>{deal.oneLiner}</p>
        <div className="kpi-grid kpi-grid-fund spacer-s">
          <Kpi label="Target net IRR" value={deal.targetNetIRR.toFixed(1) + "%"} highlight />
          <Kpi label="Coupon" value={deal.coupon} />
          <Kpi label="LTV" value={deal.ltv} />
          <Kpi label="Term" value={deal.termMonths + " months"} />
          <Kpi label="Total facility" value={fmtCcy(deal.totalSize)} />
          <Kpi label="Ticket size" value={deal.ticketSize} />
          <Kpi label="Fundraise closes" value={deal.fundraiseClose} />
          <Kpi label="Expected funding" value={deal.expectedFunding} />
        </div>
      </section>

      <section className="portal-card">
        <h2 className="portal-h2">Highlights</h2>
        <ul className="deal-bullets">
          {deal.teaserBullets.map((b, i) => <li key={i}>{b}</li>)}
        </ul>
      </section>

      {!ndaSigned ? (
        <section className="portal-card nda-gate">
          <div className="nda-lock">🔒</div>
          <h2 className="portal-h2">Full memo + data room locked</h2>
          <p className="muted">
            To access the full credit memo, financial model, security pack, photos and
            data room, sign the per-deal Confidentiality Agreement. Once signed, this
            deal stays unlocked for you for 90 days.
          </p>
          <div className="hero-actions spacer-s">
            <Link className="btn btn-primary" to={`/portal/pipeline/${deal.slug}/nda`}>
              Review and sign CA/NDA →
            </Link>
            <Link className="btn btn-ghost" to="/portal/pipeline">
              Back to pipeline
            </Link>
          </div>
        </section>
      ) : (
        <UnlockedSections deal={deal} />
      )}
    </div>
  );
}

function UnlockedSections({ deal }) {
  return (
    <>
      <section className="portal-card">
        <h2 className="portal-h2">Credit memo</h2>
        <p className="muted">Full deal memo would render here once data room data is wired.</p>
        <a className="btn btn-primary" href="#">Download memo PDF</a>
      </section>
      <section className="portal-card">
        <h2 className="portal-h2">Express interest</h2>
        <p className="muted">Indicate the amount you would like to commit to this deal.</p>
        <Link to={`/portal/pipeline/${deal.slug}/commit`} className="btn btn-primary">
          Commit £X →
        </Link>
      </section>
    </>
  );
}

function Kpi({ label, value, highlight }) {
  return (
    <div className={"kpi" + (highlight ? " kpi-strong" : "")}>
      <div className="kpi-label">{label}</div>
      <div className="kpi-value">{value}</div>
    </div>
  );
}
